import { useContext } from 'react';
import { styled } from "@mui/material";
import { useMutation, useQueryClient } from '@tanstack/react-query';
import Button from "../../../../customs/Button";
import { NotificationContext } from '../../../../providers/notification';
import apiCall from '../../../../utils/apiCall';

interface ComponentProps {
    countryId: number;
    countryName: string;
    handleClose: () => void;
}

const DeleteCountry: React.FC<ComponentProps> = ({ countryId, countryName, handleClose }) => {
    const queryClient = useQueryClient();
    const { showNotification } = useContext(NotificationContext);

    const deleteCountry = (id: number) => {
        return apiCall().delete(`/Country/DelCountry/${id}`);
    };

    const deleteCountryMutation = useMutation(['delete-country'], deleteCountry, {retry: 0});

    const deleteCountryHandler = async (id : number) => {
        try { 
            await deleteCountryMutation.mutateAsync(id, {
                onSuccess: () => {
                    showNotification({
                        message: 'Country disabled successfully',
                        type: 'success'
                    })
                    queryClient.refetchQueries(['get-countries']);
                    handleClose();
                }
            })
        } catch (error: any) {
            showNotification({
                message: error?.response?.data?.title || error?.message,
                type: 'error',
            })
        }
    };

    const handleDeleteCountry = (id : number) => deleteCountryHandler(id);
    return (
        <StyledContainer>
            <StyledText>You are about to delete <strong>{countryName}</strong></StyledText>
            <ButtonWrapper>
                <ButtonContainer>
                    <StyledButton onClick={handleClose} text='Cancel'/>
                    <StyledButton 
                        type="submit" 
                        text={deleteCountryMutation.isLoading ? 'Deleting...' : 'Yes, Delete'} 
                        onClick={() => handleDeleteCountry(countryId)}
                        disabled={deleteCountryMutation.isLoading}
                    />
                </ButtonContainer>
            </ButtonWrapper>
        </StyledContainer>
    )
}

export default DeleteCountry;

const StyledContainer = styled('div')`
    margin-inline: 3.5rem;
    margin-block: 2.5rem;
`

const ButtonWrapper = styled('div')`
    display: flex;
    justify-content: flex-end;
    margin-block: 2.5rem;
`

const ButtonContainer = styled('div')`
    display: flex;
    gap: 2rem;
`

const StyledButton = styled(Button)`
    padding-block: 1rem;
    padding-inline: 2rem;
    background-color: #DD5151;
`

const StyledText = styled('span')`
    color: #232323;
    font-size: 1.4rem;
    font-weight: 400;
`